import React,{useState, useCallback,useContext} from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Fade from '@material-ui/core/Fade';
import { makeStyles } from '@material-ui/core/styles';
import MenuIcon from '@material-ui/icons/Menu';
import IconButton from '@material-ui/core/IconButton';
import {authConfig} from '../auth/config';
import firebase from 'firebase/app';
import 'firebase/firestore'
import {withRouter} from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  menuButton: {
    marginRight: theme.spacing(2),
  },
  
}));

let listamenu=[""];
var listacao=[""];

//***************************************************carrega menu user */




//******************************************************************* */

export const FadeMenu=withRouter(({history}) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  
  
  const user = authConfig.auth().currentUser;
  var db = firebase.firestore();
  var userref = db.collection("usuarios").doc(user.uid);
  userref.get().then((doc) => {
    if (doc.exists) {
        console.log("Document data ppqpq:", doc.data());
        var utipo = doc.data().usertipo;
        var status = doc.data().userstatus;
        if(status==true){
        
          if(utipo==1){
          listamenu=[{ id: 18, label: 'Meus Deslocamentos', acao: handleMeusanalise,},
          {id: 2, label: 'Solicitar', acao: handleAgendar,},
         
          
          // { id: 4, label: 'Em Trânsito', acao: handleViagem,}
        ]
       }else {
              if ((utipo==2)||(utipo==4)){
                  listamenu=[{ id: 18, label: 'Meus Deslocamentos', acao: handleMeusanalise,},
                  {id: 2, label: 'Solicitar', acao: handleAgendar,},
                 
                  { id: 3, label: 'Gerenciar Solicitações', acao: handleConsultar,},
                  //{ id: 4, label: 'Em Trânsito', acao: handleViagem,},
                  { id: 5, label: 'Usuários', acao: handleuser,}]
              }else{
                if ((utipo==3)||(utipo==5)){
                    listamenu=[{ id: 18, label: 'Meus Deslocamentos', acao: handleMeusanalise,},
                    {id: 2, label: 'Solicitar', acao: handleAgendar,},
                   
                    { id: 3, label: 'Gerenciar Solicitações', acao: handleConsultar,},
                    //{ id: 4, label: 'Em Trânsito', acao: handleViagem,},
                    { id: 5, label: 'Usuários', acao: handleuser,}]
                   
                   
                    }else {  
                    if ((utipo==6)||(utipo==7)){
                      listamenu=[  { id: 18, label: 'Meus Deslocamentos', acao: handleMeusanalise,},
                      {id: 2, label: 'Solicitar', acao: handleAgendar,},
                     
                      { id: 3, label: 'Gerenciar Solicitações', acao: handleConsultar,},
                      { id: 16, label: 'Status das Solicitações', acao: handlefilauser,},
                      //{ id: 13, label: 'Meus Deslocamentos Concluidos', acao: handleMeus,},
                      //{ id: 15, label: 'Meus Deslocamentos em Trânsito', acao: handleMeustransito,},
                      { id: 4, label: 'Solicitações Arquivadas', acao: handleViagem,},
                      
                     // { id: 17, label: 'Fila Supervisão', acao: handlefilasupervisao,},
                      { id: 5, label: 'Usuários', acao: handleuser,},
                     { id: 7, label: 'Veículos', acao: handleveiculos,},
                      { id: 8, label: 'Motoristas', acao: handlemotoristas,},
                     
                      
                      { id: 9, label: 'Relatórios', acao: handlerelatorios},
                    ]

                      }else{  
                        if ((utipo==8)||(utipo==9)){
                        listamenu=[//{// id: 2, label: 'Solicitar', acao: handleAgendar,},
                        { id: 3, label: 'Solicitações', acao: handleConsultar,},
                        { id: 4, label: 'Solicitações Encerradas', acao: handleViagem,},
                        { id: 5, label: 'Usuários', acao: handleuser,},
                       { id: 7, label: 'Veículos', acao: handleveiculos,},
                        { id: 8, label: 'Motoristas', acao: handlemotoristas,},
                       // { id: 9, label: 'Relatórios', acao: handlerelatorios},
                        { id: 10, label :'Tipos de Veículo', acao: handletiposveiculo}]

                        }else {  
                          if (utipo==10){
                            listamenu=[{ id: 2, label: 'Solicitações', acao: handleConsultar,},
                            { id: 4, label: 'Solicitações Encerradas', acao: handleViagem,},
                            { id: 3, label: 'Usuários', acao: handleuser,},
                            { id: 4, label: 'Veículos', acao: handleveiculos,},
                            { id: 5, label: 'Motoristas', acao: handlemotoristas,},
                           // { id: 6, label: 'Relatórios', acao: handlerelatoriosupervisor},
                            { id: 7, label :'Parâmetros', acao: handleparametrosupervisao} ]

                          }else{
                            if (utipo==11){
                              listamenu=[{ id: 11, label: 'Solicitações', acao: handleConsultaragendamotorista,},
                              { id: 11, label: 'Em trânsito', acao: handlemotoristatransito,},
                              { id: 14, label: 'Teste Localização', acao: handletestmap,},
                            ]
    
                              }else{
                                if (utipo==17){
                                  listamenu=[{ id: 18, label: 'Meus Deslocamentos', acao: handleMeusanalise,},
                                  {id: 2, label: 'Solicitar', acao: handleAgendar,},
                                  { id: 11, label: 'Agenda', acao: handleConsultaragendamotorista,},
                                  { id: 11, label: 'Em trânsito', acao: handlemotoristatransito,},
                                  { id: 14, label: 'Teste Localização', acao: handletestmap,},
                                ]
        
                                  }
                              }
                          }

                        }
                      }
                    }
                }
              }
        }else{
          alert('Seu cadastro não está ativo. Solicite ao chefe do seu departamento a ativação.');
          handleLogout();
        }
      
      console.log(listamenu);

    } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
    }
    }).catch((error) => {
        console.log("Error getting document:", error);
    });
  
     
    //1
    const handleAgendar=()=>{
      
      history.push('/Agendar');

    }

    //2
    const handleConsultar=()=>{
      history.push('/Consultar');
    }
    //3
  const handleViagem=()=>{
    history.push('/consultarencerradas');

  }

    //16
    const handlefilauser=()=>{
      history.push('/filausuarios');
  
    }
    //16
    const handlefilasupervisao=()=>{
      history.push('/filasupervisao');
  
    }

  //13
  const handleMeus=()=>{
    history.push('/minhasconcluido');

  }

   //18
   const handleMeusanalise=()=>{
    history.push('/minhasanalise');

  }

  
  //13
  const handleMeustransito=()=>{
    history.push('/minhastransito');

  }
 

  //13
  const handletestmap=()=>{
    history.push('/testmap');

  }
  

  //4
  const handleuser=()=>{
    history.push('/Usuarios');
  }

  //5
  const handleaprovaviagem=()=>{
    history.push('/Aprovaviagem');

  }

    //6
  const handleveiculos=()=>{
    history.push('/Veiculos');
  }

  //7
  const handlemotoristas=()=>{
    history.push('/Motoristas');
  }

  //8
  const handlerelatorios=()=>{
    history.push('/Relatorios');

  }

  const handlerelatoriosupervisor=()=>{
    history.push('/Relatoriosupervisor');

  }

  //9
  const handletiposveiculo=()=>{
    history.push('/Parametronucleo');
  }

  //10
  const handleparametrosupervisao=()=>{
    history.push('/Parametrosupervisor');
  }

  //11
  const handleConsultaragendamotorista=()=>{
    history.push('/consultarAgendaMotorista');
  }

  //12
  const handlemotoristatransito=()=>{
    history.push('/consultarMotoristaTransito');
  }

  

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handlemenuBotao= ()=>{
    history.push('/PageInit');

  }

  async function handleLogout() {
    
    try{
      await authConfig
      
            .auth().signOut();
          
      history.push('/'); 
    }catch(error){
      console.log(error);
    }
    
  };
  

  return (
    <div>
      <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="open drawer"
            aria-controls="fade-menu" aria-haspopup="true" onClick={handleClick}
          >
            <MenuIcon />
            
          </IconButton>
     
      <Menu
        id="fade-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        <MenuItem onClick={handlemenuBotao}>Início</MenuItem>
        
        
        
        {listamenu.map((item) =>
           
          
           
            <MenuItem key={item.id} value={item.label} onClick={item.acao} >
             
             { 

             
             console.log('ação = ', item)
             
             }
              {item.label}
              
            </MenuItem>
        
        
        )}
      </Menu>
    </div>
  );
})
export default FadeMenu;